// extracted by mini-css-extract-plugin
export var cmtSDataItem = "styles-module--cmt-s-data-item--5c7f1";
export var cmtSDataItem__container = "styles-module--cmt-s-data-item__container--f88c6";
export var cmtSDataItem__pill = "styles-module--cmt-s-data-item__pill--f8c9d";
export var cmtSDataItem__text = "styles-module--cmt-s-data-item__text--e6f5f";
export var cmtSDataItem__title = "styles-module--cmt-s-data-item__title--199ee";